import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    IApproverInterface,
    IOverTime,
    ISingleOverTime,
    OverTimeDataCreateRes,
    OverTimeInput,
    SubmitOverTimeInput
} from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class OverTimeService {
    http: HttpClient = inject(HttpClient);

    getAllOverTimes(queryParams: { formTitle: string }) {
        return this.http.get<IOverTime[]>(API_URI, { params: queryParams });
    }

    createOverTime(input: OverTimeInput) {
        return this.http.post<OverTimeDataCreateRes>(`${API_URI}/create/overtime-data`, input);
    }

    submitOverTime(input: SubmitOverTimeInput) {
        return this.http.post<IOverTime>(`${API_URI}/overtime-form/submit`, input);
    }

    getSingleOverTime(id: string) {
        return this.http.get<ISingleOverTime>(`${API_URI}/single/${id}`);
    }

    getByUser(input: { id: string; query: string }) {
        return this.http.get<IOverTime[]>(`${API_URI}/user/${input.id}?formTitle=${input.query}`);
    }

    getApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IApproverInterface[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }

    deleteOverTime(id: string) {
        return this.http.delete(`${API_URI}/reimbursement-data/${id}`);
    }

    deleteReq(id: string) {
        return this.http.delete(`${API_URI}/${id}`);
    }
}
